export default {
  title: 'Beschikbaarheid pauzeren',
  description: 'Volgeboekt?',
  pause_availabilities: {
    pause_until_end_of_day: 'Reserveringen pauzeren tot het einde van de dag?',
    pause_specific_time: 'Reserveringen pauzeren voor een andere dag en/of tijd',
  },
  pause_reservations_today: 'Reserveringen vandaag pauzeren',
  pause_reservations_another_day: 'Reserveringen pauzeren voor een andere dag',
  paused_availabilities_form: {
    date_time: {
      label: 'Selecteer een datum en tijd',
    },
    reason: {
      label: 'Voeg een reden toe (optioneel)',
      placeholder: 'Voer beschrijving in...',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  error_messages: {
    creation_failed: 'Aanmaken van uitzondering mislukt',
  },
};
